$('.slide-collections').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 5,
    asNavFor: '.slide-products',
    prevArrow:'<svg xmlns="http://www.w3.org/2000/svg" width="7.746" height="15.497" viewBox="0 0 7.746 15.497"><defs><style>.a{fill:#a4a8b2;}</style></defs><path class="a" d="M18.45,22.995a1.107,1.107,0,0,1-.863-.41l-5.346-6.641a1.107,1.107,0,0,1,0-1.406L17.775,7.9a1.108,1.108,0,1,1,1.7,1.417l-4.947,5.932,4.781,5.932a1.107,1.107,0,0,1-.863,1.815Z" transform="translate(-11.989 -7.498)"/></svg>',
    nextArrow:'<svg style="right:0" xmlns="http://www.w3.org/2000/svg" width="7.813" height="15.53" viewBox="0 0 7.813 15.53"><defs><style>.a{fill:#a4a8b2;}</style></defs><path class="a" d="M14.606,22.984a1.107,1.107,0,0,1-.852-1.815l4.958-5.932L13.931,9.293A1.131,1.131,0,1,1,15.713,7.9l5.346,6.641a1.107,1.107,0,0,1,0,1.406l-5.534,6.641a1.107,1.107,0,0,1-.919.4Z" transform="translate(-13.497 -7.456)"/></svg>',
    responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToShow:1
          }
        }
    ]
});
$('.slide-products').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 1,
    asNavFor: '.slide-collections',
    arrows:false,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false,
            centerPadding: '0px'
          }
        }
    ]
});

$('.slide-text-columns').slick({
    responsive: [
        {
          breakpoint: 4480,
          settings: 'unslick'
        },
        {
          breakpoint: 769,
          settings: {
            centerMode: false,
            slidesToShow: 1,
            arrows: false,
            dots: true
          }
        }
    ]
    
});
$('.slide-fc').slick({
    responsive: [
        {
          breakpoint: 4480,
          settings: 'unslick'
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: true
          }
        }
    ]
    
});
$('.slide-blog').slick({
    responsive: [
        {
          breakpoint: 4480,
          settings: 'unslick'
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows: false,
            dots: true
          }
        }
    ]
    
});

$('.slide-product-set').slick({
  responsive: [
      {
        breakpoint: 4480,
        settings: 'unslick'
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
  ]
  
});


window.addEventListener('DOMContentLoaded',()=>{

  const tiendaBtn = document.getElementById('tiendaBtn')
  const tiendaRetailOpen = document.getElementById('tiendaRetailOpen')
  const closeBtn = document.getElementById('closeBtn')
  let dropdown  = document.querySelectorAll('.dropdown')
  let dropdownHidden = document.querySelectorAll('.dropdownHidden')

  tiendaBtn.addEventListener('click', (e)=>{
    e.preventDefault()
    tiendaRetailOpen.classList.add('modal-2__open')
  })

  closeBtn.addEventListener('click', (e)=>{
    tiendaRetailOpen.classList.remove('modal-2__open')
  })

  dropdown.forEach((element, i) => {
    dropdown[i].addEventListener('click', ()=>{
      dropdownHidden.forEach((element, i) => {
        dropdownHidden[i].classList.remove('active')       
      });
      dropdownHidden[i].classList.add('active')     
    }) 
  });


  if (location.pathname.includes('/collections/')) {  
    const collection = location.pathname.split('/collections/')[1]  
    const collectionName = collection.split('/')[0]
    const hasFilters = collection.split('/')[1]
    let filters = []

    if (hasFilters) {
      const arrayFilters = hasFilters.split('+').map(filter => {
        const tagParent = filter.split('=')
        return {
          tag : tagParent[1],
          parent : tagParent[0]
        }       
      })

      filters.push(...arrayFilters)
      
      filters.forEach((filter,i) => {
        const checkbox = document.querySelector(`.filterBox[data-tag=${filter.tag}][data-parent=${filter.parent}]`)
        checkbox.checked = true
      });
    }
    

    const [...allCheckboxes] = document.querySelectorAll('.filterBox')
    allCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('click', (evt)=>{
        const thisTag = checkbox.dataset.tag
        const parent = checkbox.dataset.parent
        const existFilter = filters.filter(filter => filter.parent === parent)
        let isNew = true
        if (existFilter.length > 0) {
          const relatedCheckbox =  document.querySelector(`input[data-tag="${existFilter[0].tag}"][data-parent="${existFilter[0].parent}"]`)
          
          if ( collection.includes(existFilter[0].tag) ) isNew = false 

          relatedCheckbox.checked = false;
          filters.splice(filters.findIndex( filter => filter === existFilter[0] ), 1 );
          filters.push({
            tag: thisTag,
            parent: parent         
          })
        }
         
        if (isNew) {
          filters.push({
            tag: thisTag,
            parent: parent         
          })
        }
        
// 		history.pushState({}, '', `/collections/${collectionName}/` + filters.map( elem => `${elem.parent}=${elem.tag}` ).join('+'));
        location.href = `/collections/${collectionName}/` + filters.map( elem => `${elem.parent}=${elem.tag}` ).join('+');
      }) 
      
    });

  }



})